import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import planConstraintModel from "src/models/constraint"
import collection from "src/hocs/collection"

const configurator = ({ planId, basicUrl }) => ({
  engine: entity,
  to: `constraints`,
  model: planConstraintModel(planId, basicUrl),
  query: {
    limit: -1,
  },
})

export default config =>
  compose(
    collection(props => ({
      ...configurator(props),
      ...(isFunction(config) ? config(props) : config),
    })),
  )
